import { openApiSchema } from './openApiSchema';

export function getRequestBodySchema<Path extends keyof typeof openApiSchema.paths, Method extends keyof (typeof openApiSchema.paths)[Path]>(
    path: Path,
    method: Method,
) {
    return (openApiSchema.paths[path][method] as any).requestBody?.content['application/json'].schema;
}
